// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Viewmodel
import { VhiInsurerVm } from 'app/_mapper/vhiinsurer.vm';

export class SelectedhealthPolicyVm {
    @AutoMap() vhiIsManual: boolean;
    @AutoMap() vhiInsurer: VhiInsurerVm;
    @AutoMap() vhiAlarmcenter?: any;
    @AutoMap() vhiHealthInsuranceNumber: string;
    @AutoMap() vhiDateofBirth: Date;
    @AutoMap() vhiInsurerPhonenumber?: any;
    @AutoMap() vhiStatusPolisCheck: string;
    @AutoMap() vhiTypePolicyCheck: string;
    @AutoMap() vhiComments: string;
}
